import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { LuArrowBigUp } from 'react-icons/lu';
import { LuArrowBigDown } from 'react-icons/lu';
import styled from 'styled-components';
import { formatFixedTrimmed } from '../../../utils/format';
import { FaTimes } from 'react-icons/fa';
import './Account-Manager.scss';
import { useMetricsContext } from '../../../contexts/Metrics-Context.js';

const Heading = styled.div`
  font-size: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 5px !important;
  white-space: nowrap !important;
  color: var(--content-primary, #e8eaf0); /* boldTextColor */
`;
const Container = styled.div`
  display: flex;
  background-color: var(--surface-panel, #252b42); /* firstBox */
  padding: 5px !important;
  border-radius: 5px;
`;
const FlexStart = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 5px;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
`;
const FlexEnd = styled.div`
  display: flex;
  justify-content: end;
  gap: 5px;
  margin-right: 10px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  @media (max-width: 540px) {
    justify-content: flex-start;
  }
`;
const PositionEvent = ({ positionInfo }) => {
  const { setShowDealsModal } = useMetricsContext();

  const modalContent = (
    <>
      <div className="position-info-backdrop" style={{ zIndex: 100000000 }}></div>
      <div className="wm-parent" onClick={() => setShowDealsModal(false)} style={{ zIndex: 100000001 }}>
        <div
          className={`window-module responsive-modal`}
          style={{ position: 'fixed', top: '25%', zIndex: 100000001 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="wm-header">
            <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
              <h2 className="wmTitleDynamic">Position Events</h2>
              <h2 className="wmTitleDynamic">Position ID : PID{positionInfo[0]?.resulting_position_id.toString().padStart(8, "0") || "---" } </h2>
            </div>
            <div
              className="wm-exit close-icon"
              onClick={() => setShowDealsModal(false)}
            >
              <FaTimes />
            </div>
          </div>
          <div className="wm-content">
            <div className="wm-read-p-in-start">
              <p style={{ textAlign: 'start' }}></p>
            </div>
          </div>

          <div style={{ width: '100%', paddingTop: '20px', overflow: 'auto', height:'280px' }}>
            {positionInfo.map((item) =>
              item.position_impact === 'Opening' ? (
                <FlexStart key={item.dealId}>
                  <Container>
                    {item.direction === 'Buy' ? (
                      <LuArrowBigUp
                        size={20}
                        color={item.direction === 'Buy' ? '#00d97e' : '#ff4757'} // greenButton, redButton
                      />
                    ) : (
                      <LuArrowBigDown
                        size={20}
                        color={item.direction === 'Buy' ? '#00d97e' : '#ff4757'} // greenButton, redButton
                      />
                    )}
                    <Heading>Margin {formatFixedTrimmed(item?.margin, 4)}</Heading>
                  </Container>
                  <Container>
                    <Heading
                      style={{
                        color: item.direction === 'Buy' ? '#00d97e' : '#ff4757', // greenButton, redButton
                      }}
                    >
                      {item.position_impact}
                    </Heading>
                    <Heading>
                      DEAL {item?.dealId?.toString().padStart(8, '0')}
                    </Heading>
                    <Heading>
                      {`${new Date(item.position_opened_at).toLocaleDateString('en-GB')},
                                        ${new Date(
                                          item.position_opened_at,
                                        ).toLocaleTimeString('en-GB', {
                                          hour: '2-digit',
                                          minute: '2-digit',
                                          hour12: false,
                                        })}`}
                    </Heading>
                    <Heading>Qty {formatFixedTrimmed(item?.quantity, 8)}</Heading>
                    <Heading>{item.symbol}</Heading>
                    <Heading>
                      Price {formatFixedTrimmed(item.exit_price, 8)}
                    </Heading>
                  </Container>
                </FlexStart>
              ) : (
                <FlexStart key={item.dealId}>
                  <Container>
                    {item.direction === 'Buy' ? (
                      <LuArrowBigUp
                        size={20}
                        color={item.direction === 'Buy' ? '#21C16C' : '#E13232'}
                      />
                    ) : (
                      <LuArrowBigDown
                        size={20}
                        color={item.direction === 'Buy' ? '#21C16C' : '#E13232'}
                      />
                    )}
                    <Heading>Margin {formatFixedTrimmed(item?.margin, 4)}</Heading>
                  </Container>
                  <Container>
                    <Heading
                      style={{
                        color: item.direction === 'Buy' ? '#00d97e' : '#ff4757', // greenButton, redButton
                      }}
                    >
                      {item.position_impact}
                    </Heading>
                    <Heading>
                      DEAL {item?.dealId?.toString().padStart(8, '0')}
                    </Heading>
                    <Heading>
                      {`${new Date(item.position_opened_at).toLocaleDateString('en-GB')},
                                        ${new Date(
                                          item.position_opened_at,
                                        ).toLocaleTimeString('en-GB', {
                                          hour: '2-digit',
                                          minute: '2-digit',
                                          hour12: false,
                                        })}`}
                    </Heading>
                    <Heading>Qty {formatFixedTrimmed(item?.quantity, 8)}</Heading>
                    <Heading>{item.symbol}</Heading>
                    <Heading>
                      Price {formatFixedTrimmed(item.exit_price, 8)}
                    </Heading>
                  </Container>
                </FlexStart>
              ),
            )}
          </div>
        </div>
      </div>
    </>
  );

  return createPortal(modalContent, document.body);
};

export default memo(PositionEvent);
